"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createApiRequestAction = createApiRequestAction;
var _constants = require("../constants");
function updatePaginationEndClause(dispatch, paginationEndConstant, paginationPayload, response) {
  switch (paginationEndConstant) {
    case _constants.MEMBER_GROUPS_PAGINATED:
      paginationPayload.hasMoreMemberGroupsPagination = (response === null || response === void 0 ? void 0 : response.data.length) !== 0;
      break;
    case _constants.ORGANIZATION_MEMBERS_PAGINATED:
      paginationPayload.hasMoreMembersPagination = (response === null || response === void 0 ? void 0 : response.data.length) !== 0;
      break;
    case _constants.MEMBER_GROUP_USERS_PAGINATED:
      paginationPayload.hasMoreMembersPagination = (response === null || response === void 0 ? void 0 : response.data.length) !== 0;
      break;
    default:
      break;
  }
  dispatch({
    type: paginationEndConstant,
    payload: paginationPayload
  });
}
function createApiRequestAction(_ref) {
  var getKey = _ref.getKey,
    request = _ref.request,
    loadingConstant = _ref.loadingConstant,
    loadedConstant = _ref.loadedConstant,
    errorConstant = _ref.errorConstant,
    paginationEndConstant = _ref.paginationEndConstant,
    additionalPayload = _ref.additionalPayload,
    successCallback = _ref.successCallback;
  var action = function action() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return function (dispatch, getState) {
      var _getState = getState(),
        loading = _getState.loading,
        session = _getState.session;
      var organizationId = session.get('selected_organization_id');
      var key = getKey.apply(void 0, args);
      if (loading.has(key)) return loading.get(key);
      var payloadExtras = {};
      if (additionalPayload) payloadExtras = _objectSpread({}, additionalPayload(session));
      var promise = request.apply(void 0, [getState].concat(args)).then(function (response) {
        dispatch({
          type: loadedConstant,
          payload: _objectSpread(_objectSpread({
            key: key
          }, response), payloadExtras)
        });
        if (paginationEndConstant) updatePaginationEndClause(dispatch, paginationEndConstant, {
          key: key,
          organizationId: organizationId
        }, response);
        if (successCallback) successCallback.apply(void 0, [dispatch, getState, response].concat(args));
        return response;
      }).catch(function (error) {
        dispatch({
          type: errorConstant,
          payload: {
            error: error,
            key: key
          }
        });
        throw error;
      });
      dispatch({
        type: loadingConstant,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  action.getKey = getKey;
  return action;
}